import { Component, Input, ChangeDetectionStrategy, Injector } from '@angular/core'
import { Store } from '@ngrx/store'
import { NavController } from 'ionic-angular'
import { UIEventHub } from '../../../services/event.service'
import { ActionCreator } from '../../../services/action.service'
import { ViewModel } from '../../../view-model'
import { BaseWidget } from '../../base-widget'
/**
 * プルダウンカラム
 *【選択候補:items:{label:string,value:string}[]】
 *【未選択文言:placeholder:string】
 *【未選択値:defaultValue:string】
 *【未選択値選択肢:includeDefaultValue:boolean = true】
 *【選択項目:selectedValue:string】
 *【非活性:disabled:boolean】
 * @author nabla2.metamodel.generator
 */
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-pulldown-column',
  templateUrl: './pulldown-column.html',
  styles: [`
    
  `]
})
export class PulldownColumn extends BaseWidget {
  /**
   * 項目添字
   */
  @Input() index:number

  /**
   * リスト内容
   */
  @Input() records:any[]

  /**
   * 選択項目の表示モデルパス
   */
  @Input() viewModelPath:string

  /**
   * 選択項目に対する精査エラー
   */
  @Input() errorMessages:{modelPath:string, message:string}[]

  /**
   * 選択候補
   */
  @Input() items:{label:string,value:string}[]

  /**
   * 未選択文言
   */
  @Input() placeholder:string

  /**
   * 未選択値
   */
  @Input() defaultValue:string

  /**
   * 未選択値選択肢
   */
  @Input() includeDefaultValue:boolean = true

  /**
   * 選択項目
   */
  @Input() selectedValue:string

  /**
   * 非活性
   */
  @Input() disabled:boolean

  /**
   * コンストラクタ
   * @param navCtrl 画面遷移管理サービス
   * @param store Reduxストア
   */
  constructor(
    public navCtrl: NavController,
    public store: Store<{viewModel:ViewModel}>,
    public eventHub: UIEventHub,
    public actionCreator: ActionCreator,
    public injector: Injector,
  ) {
    super(injector)
  }
  get htmlId():string {
    return `${this.id}[${this.index}]`
  }
  updateSelectedValue(event, index) {
    const value = event['value']
    this.store.dispatch(this.actionCreator.updateViewModel(
      this.viewModelPath,
      (m) => value,
      {id:this.id, type:event['event'].type, source:event['event']},
      `update by ${this.id}`,
    ))
    const exist = this.items.filter(e => e.value === value)
    const content = !!exist && exist.length > 0 ? exist[0]['label'] : ''
    const type = (typeof event['event'] === 'string') ? event['event'] : event['event'].type
    this.eventHub.next({
      id: this.id,
      type: type,
      source: {},
      index: index,
      content: content,
    })
    if (this.selectedValue !== value) {
      this.records[index]['_changed'] = true
      this.eventHub.next({
        id: this.id,
        type: "change",
        source: {},
        index: index,
        content: content,
      })
    }
    return value
  }
  
  get options() {
    const options = {
      options: !!this.items ? this.items : [],
      defaultValue: this.defaultValue
    }
    return options;
  }
  /**
   * このコンポーネントの状態をバインドされた表示項目の状態に反映する。
   * @param event イベント
   */
  update(event:Event) {
    const node = <HTMLFormElement>event.target
    const value = node.value
    this.store.dispatch(this.actionCreator.updateViewModel(
      this.viewModelPath,
      (m) => value,
      {id:this.id, type:event.type, source:event},
      `update by ${this.id}`,
    ))
    this.on(event)
  }
}


// WEBPACK FOOTER //
// ./src/widgets/table/pulldown-column/pulldown-column.component.ts